<template>
<div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>

    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Sales Help</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
        <v-container fluid>
            <v-layout row wrap>
                <v-flex>
                    <v-container  fluid grid-list-xl >
                      <v-layout style="margin-bottom:10px" justify-start row wrap>
                        <v-flex>
                          <h2  class="subheading font-weight-medium">
                              This section is where you can view all the orders that have been made by the customers. It is broken down into 2 main sections In-Progress or Shipped. You can also choose to view all of the orders together ordered by date. All of the orders made by the customers would have to be manually shipped by a seller.
                          </h2>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-start row wrap>
                        <v-flex>
                          <h1 style="margin-bottom:5px"  class="title font-weight-bold">In-Progress</h1>
                          <h2 class="subheading">When a customer makes a payment for an order , that order would first be sent to the in-progress section. This is where you as a seller can review the order before shipping.</h2>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-start row wrap>
                        <v-flex>
                          <h1 style="margin-bottom:5px"  class="title font-weight-bold">Shipped</h1>
                          <h2 class="subheading">When the order has been shipped, you have the option of viewing the shipment details. This includes the email you sent the customer upon shipping, tracking number and also viewing the current location of the shipment. You also have the option of changing the tracking number.</h2>
                        </v-flex>
                      </v-layout>
                    </v-container>

                                         <!----------------------  OBTAINING AN ORDER NUMBER EXPANSION PANEL   -------------------->
                      <v-layout class="mb-1">
                        <v-flex>
                          <v-expansion-panel>
                            <v-expansion-panel-content>
                              <template v-slot:header>
                                <div> <h1 class="title font-weight-bold">Obtaining an Order Number</h1></div>
                              </template>
                              <v-card>
                                <v-container fluid grid-list-md>
                                  <v-layout row wrap >
                                    <v-flex xs2 md1 class="text-xs-center">
                                      <div class="round-number">
                                        1
                                      </div>
                                    </v-flex>
                                    <v-flex xs10 md11 class="text-xs-left pt-2">
                                      <h3 class="subheading font-weight-bold">
                                        Select an order from the Sales section
                                      </h3>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout>
                                    <v-flex xs2 md1 class="text-xs-center">
                                      <div class="round-number">
                                        2
                                      </div>
                                    </v-flex>
                                    <v-flex xs10 md11 class="text-xs-left pt-2">
                                      <h3 class="subheading font-weight-bold">
                                        Once you’ve selected and entered the page, the order number is located right at the top
                                      </h3>
                                      <div class="mb-5 mt-4">
                                        <img src="/static/img/help/sales/ObtainOrderNumber.jpg" style="max-width:90%;" />
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                </v-container>

                              </v-card>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-flex>
                      </v-layout>

                      <!----------------------  SHIPPING AN ORDER EXPANSION PANEL   -------------------->
                      <v-layout class="mb-1">
                        <v-flex>
                          <v-expansion-panel>
                            <v-expansion-panel-content>
                              <template v-slot:header>
                                <div> <h1 class="title font-weight-bold">Shipping an Order</h1></div>
                              </template>
                              <v-card>
                                <v-container fluid grid-list-md>

                                  <v-layout row wrap >
                                    <v-flex xs2 md1 class="text-xs-center">
                                      <div class="round-number">
                                        1
                                      </div>
                                    </v-flex>
                                    <v-flex xs10 md11 class="text-xs-left pt-2">
                                      <h3 class="subheading font-weight-bold">
                                        Select an order from the In-Progress section
                                      </h3>
                                      <div class="mb-5 mt-4">
                                        <img src="/static/img/help/sales/In-ProgressSales.jpg" style="max-width:90%;" />
                                      </div>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout>
                                    <v-flex xs2 md1 class="text-xs-center">
                                      <div class="round-number">
                                        2
                                      </div>
                                    </v-flex>
                                    <v-flex xs10 md11 class="text-xs-left pt-2">
                                      <h3 class="subheading font-weight-bold">
                                        Once you’ve selected an order, simply scroll to the bottom and click Ship Order
                                      </h3>
                                      <div class="mb-5 mt-4">
                                        <img src="/static/img/help/sales/ShipOrder.jpg" style="max-width:90%;" />
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                </v-container>
                              </v-card>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-flex>
                      </v-layout>

                             <!----------------------  VIEW SHIPMENT DETAILS EXPANSION PANEL   -------------------->
                      <v-layout class="mb-1">
                        <v-flex>
                          <v-expansion-panel>
                            <v-expansion-panel-content>
                              <template v-slot:header>
                                <div> <h1 class="title font-weight-bold">View Shipment Details</h1></div>
                              </template>
                              <v-card>
                                <v-container fluid grid-list-md>
                                  <v-layout row wrap >
                                    <v-flex xs2 md1 class="text-xs-center">
                                      <div class="round-number">
                                        1
                                      </div>
                                    </v-flex>
                                    <v-flex xs10 md11 class="text-xs-left pt-2">
                                      <h3 class="subheading font-weight-bold">
                                        Select an order from the Shipped section
                                      </h3>
                                      <div class="mb-5 mt-4">
                                        <img src="/static/img/help/sales/ShippedSales.jpg" style="max-width:90%;" />
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex xs2 md1 class="text-xs-center">
                                      <div class="round-number">
                                        2
                                      </div>
                                    </v-flex>
                                    <v-flex xs10 md11 class="text-xs-left pt-2">
                                      <h3 class="subheading font-weight-bold">
                                        Once you’ve selected an order, click on the View button
                                      </h3>
                                       <div class="mb-5 mt-4">
                                        <img src="/static/img/help/sales/SalesDetailView.jpg" style="max-width:90%;" />
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex xs2 md1 class="text-xs-center">
                                      <div class="round-number">
                                        3
                                      </div>
                                    </v-flex>
                                    <v-flex xs10 md11 class="text-xs-left pt-2">
                                      <h3 class="subheading font-weight-bold">
                                        This will take you to a page where you then click on the next arrow located to the right of the shipment.
                                      </h3>
                                       <div class="mb-5 mt-4">
                                        <img src="/static/img/help/sales/OrderShipments.jpg" style="max-width:90%;" />
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex xs2 md1 class="text-xs-center">
                                      <div class="round-number">
                                        4
                                      </div>
                                    </v-flex>
                                    <v-flex xs10 md11 class="text-xs-left pt-2">
                                      <h3 class="subheading font-weight-bold">
                                        Finally you arrive at the shipment page where you can view the details
                                      </h3>
                                      <ul >
                                        <li><h4 class="body-2 font-weight-regular">The TRACK button allows you to track the items current location</h4></li>
                                        <li><h4 class="body-2 font-weight-regular">VIEW EMAIL allows you to see the email sent to the customers upon shipment</h4></li>
                                        <li><h4 class="body-2 font-weight-regular">EDIT allows you to edit the tracking details such as courier and tracking number</h4></li>
                                      </ul>
                                      <div class="mb-5 mt-4">
                                        <img src="/static/img/help/sales/ShipmentDetails.jpg" style="max-width:90%;" />
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                </v-container>
                              </v-card>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-flex>
                      </v-layout>

                          <!----------------------  CONTACTING CUSTOMER EXPANSION PANEL   -------------------->
                      <v-layout class="mb-1">
                        <v-flex>
                          <v-expansion-panel>
                            <v-expansion-panel-content>
                              <template v-slot:header>
                                <div> <h1 class="title font-weight-bold">Contacting a Customer</h1></div>
                              </template>
                              <v-card>
                                <v-container fluid grid-list-lg>
                                  <v-layout row wrap align-center>
                                    <v-flex xs2 md1 class="text-xs-center">
                                      <div class="round-number">
                                        1
                                      </div>
                                    </v-flex>
                                    <v-flex xs10 md11 class="text-xs-left pt-2">
                                      <h3 class="subheading font-weight-bold">
                                        Select the order of the customer you’d like to contact
                                      </h3>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex xs2 md1 class="text-xs-center">
                                      <div class="round-number">
                                        2
                                      </div>
                                    </v-flex>
                                    <v-flex xs10 md11 class="text-xs-left pt-2">
                                      <h3 class="subheading font-weight-bold">
                                        Then click on SEND MSG
                                      </h3>
                                      <div class="mb-5 mt-4">
                                        <img src="/static/img/help/sales/ClickSendMsg.jpg" style="max-width:90%;" />
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex xs2 md1 class="text-xs-center">
                                      <div class="round-number">
                                        3
                                      </div>
                                    </v-flex>
                                    <v-flex xs10 md11 class="text-xs-left pt-2">
                                      <h3 class="subheading font-weight-bold">
                                        You’ll be taken to a page where you can create a ‘ticket’.
                                      </h3>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex xs2 md1 class="text-xs-center">
                                      <div class="round-number">
                                        4
                                      </div>
                                    </v-flex>
                                    <v-flex xs10 md11 class="text-xs-left pt-2">
                                      <h3 class="subheading font-weight-bold">
                                        Fill in the Category, Title and Message field. The Order No, Buyer and Staff is automatically filled in
                                      </h3>
                                      <div class="mb-5 mt-4">
                                        <img src="/static/img/help/sales/TicketCreationField.jpg" style="max-width:90%;" />
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex xs2 md1 class="text-xs-center">
                                      <div class="round-number">
                                        5
                                      </div>
                                    </v-flex>
                                    <v-flex xs10 md11 class="text-xs-left pt-2">
                                      <h3 class="subheading font-weight-bold">
                                        You can add or remove staffs from the ticket by clicking on the Staffs row and then choosing the staff you wish to add or remove.
                                      </h3>
                                      <div class="mb-5 mt-4">
                                        <img src="/static/img/help/sales/AddingStaffs.jpg" style="max-width:90%;" />
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex xs2 md1 class="text-xs-center">
                                      <div class="round-number">
                                        6
                                      </div>
                                    </v-flex>
                                    <v-flex xs10 md11 class="text-xs-left pt-2">
                                      <h3 class="subheading font-weight-bold">
                                         Once done with filling in all the fields, click the Send Message down at the bottom
                                      </h3>
                                      <div class="mb-5 mt-4">
                                        <img src="/static/img/help/sales/SendMessage.jpg" style="max-width:90%;" />
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                </v-container>
                              </v-card>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-flex>
                      </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</div>
</template>

<script>

import SideDrawer from '@/components/SideDrawer.vue'

export default {
  data () {
    return {
      drawer: false
    }
  },
  components: {
    SideDrawer
  },
  mounted () {
    this.openDrawerForDesktop()
  }
}
</script>

<style scoped>

.round-number {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background-color: #ff0000;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  padding-top: 3px;
}

</style>
